import React, { useState, useEffect } from 'react';
import '../styles/DavidGroupLessonButton.css';  // CSSファイルを別途作成
const GROUP_LESSON_OPEN = true; // ここで表示/非表示を切り替える

const DavidGroupLessonButton = () => {
  const [isLessonOpen, setIsLessonOpen] = useState(GROUP_LESSON_OPEN);

  if (!isLessonOpen) {
    return null; // 定員がいっぱいの場合は非表示
  }

  return (
    <div className="lesson-container">
      <h2 className="lesson-title">David Falvey特別コース</h2>
      <p className="lesson-date">11月2日開講！全4回(隔週土曜日)</p>
      <a href="/grouplesson-david" className="lesson-button">詳細はこちら</a>
    </div>
  );
};

export default DavidGroupLessonButton;

